export default "__VITE_ASSET__W7patEzu__"